import { useState } from 'react';

const menCategories = [
  {
    title: 'Topwear',
    items: [
      { name: 'Half Sleeve T-shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt' },
      { name: 'Full Sleeve T-shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Full%20Sleeve%20T-shirt' },
      { name: 'Polo T-shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Polo%20T-shirt' },
      { name: 'Shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Shirt' },
      { name: 'Panjabi', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Panjabi' },
      { name: 'Hoodie', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Hoodie' },
      { name: 'Jacket', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Jacket' },
      { name: 'Sweatshirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Sweatshirt' },
    ],
  },
  {
    title: 'Bottomwear',
    items: [
      { name: 'Comfy Trouser', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Comfy%20Trouser' },
      { name: 'Sports Trouser', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Sports%20Trouser' },
      { name: 'Jeans', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Jeans' },
      { name: 'Joggers', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Joggers' },
      { name: 'Cargo Pants', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Cargo%20Pants' },
      { name: 'Chino Pants', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Chino%20Pants' },
      { name: 'Shorts', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Shorts' },
      { name: 'Pajama', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Pajama' },
    ],
  },
  {
    title: 'Accessories',
    items: [
      { name: 'Face Mask', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Face%20Mask' },
      { name: 'Underwear', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Underwear' },
      { name: 'Socks', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Socks' },
      { name: 'Wallet', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Accesorries%20%3E%20Wallet' },
      { name: 'Cap', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Accesorries%20%3E%20Cap' },
      { name: 'Belt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Accesorries%20%3E%20Belt' },
    ],
  },
];

const womenCategories = [
  {
    title: 'Western & Ethnic',
    items: [
      { name: 'Kurti Tunic And Tops', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Kurti%20Tunic%20And%20Tops' },
      { name: 'T-Shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20T-Shirt' },
      { name: 'Comfy Trouser', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Comfy%20Trouser' },
      { name: 'Pajamas', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Pajamas' },
      { name: 'Co-ords', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Co-ords' },
      { name: 'Shrug', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Shrug' },
      { name: 'Palazzo', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Palazzo' },
      { name: 'Pants', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Pants' },
      { name: 'Leggings', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Leggings' },
      { name: '3pc Salwar Kameez', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%203pc%20Salwar%20Kameez' },
    ],
  },
];

const kidsCategories = [
  {
    title: 'Boys',
    items: [
      { name: 'Half Sleeve T-shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Half%20Sleeve%20T-shirt' },
      { name: 'Full Sleeve T-shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Full%20Sleeve%20T-shirt' },
      { name: 'Trouser', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Trouser' },
      { name: 'Shorts', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Shorts' },
    ],
  },
  {
    title: 'Girls',
    items: [
      { name: 'T-shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Girls%20%3E%20T-shirt' },
      { name: 'Trouser', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Girls%20%3E%20Trouser' },
      { name: 'Shorts', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Girls%20%3E%20shorts' },
    ],
  },
];

const newArrivals = [
  { title: 'Mens Premium Chino Pant - Mantrim', image: 'https://fabrilife.com/image-gallery/697eddd27f672-square.jpg', url: '/product/73869-mens-premium-chino-pant-mantrim' },
  { title: 'Mens Premium Formal Shirt - Skynet', image: 'https://fabrilife.com/image-gallery/697f51562d82b-square.jpg', url: '/product/73958-mens-premium-formal-shirt-skynet' },
  { title: 'Mens Premium Formal Shirt - Dyquard', image: 'https://fabrilife.com/image-gallery/697f51b4cd390.jpg', url: '/product/73957-mens-premium-formal-shirt-dyquard' },
  { title: 'Mens Premium Formal Shirt - Orchestra', image: 'https://fabrilife.com/image-gallery/697f50b343ced.jpg', url: '/product/73956-mens-premium-formal-shirt-orchestra' },
];

const womenNewArrivals = [
  { title: 'Womens Premium Kurti - Elizarna', image: 'https://fabrilife.com/image-gallery/69722a3a15ee7-square.jpg', url: '/product/73947-womens-premium-kurti-elizarna' },
  { title: 'Women Premium Co-ords - Sandora', image: 'https://fabrilife.com/image-gallery/6963675399e21-square.jpg', url: '/product/73762-women-premium-co-ords-sandora' },
  { title: 'Women Premium Hoodie - Dazzelina', image: 'https://fabrilife.com/image-gallery/69660e9d1d1ed-square.jpg', url: '/product/73863-women-premium-hoodie-dazzelina' },
];

export default function Header({ cartCount = 0 }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [expandedCategories, setExpandedCategories] = useState({});

  const toggleCategory = (id) => {
    setExpandedCategories(prev => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <>
      {/* ── Desktop Header ── */}
      <header className="hidden lg:block fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
        <div className="border-b border-gray-200">
          <div className="max-w-[1400px] mx-auto px-4">
            <div className="flex items-center justify-between h-[60px] gap-6">

              {/* Logo */}
              <div className="flex-shrink-0">
                <a href="/">
                  <img src="https://fabrilife.com/img/fabrilife.svg" alt="Fabrilife" className="h-8" />
                </a>
              </div>

              {/* Navigation */}
              <nav className="flex-shrink-0">
                <ul className="flex items-center space-x-8 text-sm font-medium">

                  {/* Men */}
                  <li className="relative group">
                    <span className="cursor-pointer py-5 inline-block hover:text-gray-600 transition-colors">Men</span>
                    <div className="absolute left-0 top-full w-screen max-w-[50vw] bg-white shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                      <div className="p-8">
                        <div className="grid grid-cols-3 gap-8">
                          {menCategories.map((cat, idx) => (
                            <div key={idx}>
                              <h4 className="font-medium text-black text-[15px] mb-3">
                                <a href="/shop?refinementList%5Bcats%5D%5B0%5D=Mens" className="hover:text-gray-600">{cat.title}</a>
                              </h4>
                              <ul className="space-y-2">
                                {cat.items.map((item, i) => (
                                  <li key={i}><a href={item.url} className="text-[14px] text-gray-600 hover:text-black transition-colors">{item.name}</a></li>
                                ))}
                              </ul>
                            </div>
                          ))}
                        </div>
                        <div className="mt-8 pt-8 border-t border-gray-200">
                          <h4 className="font-medium text-black mb-4">New Arrivals</h4>
                          <div className="grid grid-cols-4 gap-4">
                            {newArrivals.map((p, idx) => (
                              <a key={idx} href={p.url} className="group">
                                <div className="aspect-square overflow-hidden rounded-lg mb-2">
                                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" />
                                </div>
                                <div className="text-sm text-gray-700">{p.title.substring(0, 30)}...</div>
                              </a>
                            ))}
                          </div>
                        </div>
                        <div className="mt-6 text-right">
                          <a href="/shop?refinementList%5Bcats%5D%5B0%5D=Mens" className="text-sm font-medium hover:text-gray-600">View All Men →</a>
                        </div>
                      </div>
                    </div>
                  </li>

                  {/* Women */}
                  <li className="relative group">
                    <span className="cursor-pointer py-5 inline-block hover:text-gray-600 transition-colors">Women</span>
                    <div className="absolute left-0 top-full w-screen max-w-[50vw] bg-white shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                      <div className="p-8">
                        <div className="grid grid-cols-3 gap-8">
                          {womenCategories.map((cat, idx) => (
                            <div key={idx}>
                              <h4 className="font-medium text-black text-[15px] mb-3">
                                <a href="/shop?refinementList%5Bcats%5D%5B0%5D=Womens" className="hover:text-gray-600">{cat.title}</a>
                              </h4>
                              <ul className="space-y-2">
                                {cat.items.map((item, i) => (
                                  <li key={i}><a href={item.url} className="text-[14px] text-gray-600 hover:text-black transition-colors">{item.name}</a></li>
                                ))}
                              </ul>
                            </div>
                          ))}
                        </div>
                        <div className="mt-8 pt-8 border-t border-gray-200">
                          <h4 className="font-medium text-black mb-4">New Arrivals</h4>
                          <div className="grid grid-cols-4 gap-4">
                            {womenNewArrivals.map((p, idx) => (
                              <a key={idx} href={p.url} className="group">
                                <div className="aspect-square overflow-hidden rounded-lg mb-2">
                                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" />
                                </div>
                                <div className="text-sm text-gray-700">{p.title.substring(0, 30)}...</div>
                              </a>
                            ))}
                          </div>
                        </div>
                        <div className="mt-6 text-right">
                          <a href="/shop?refinementList%5Bcats%5D%5B0%5D=Womens" className="text-sm font-medium hover:text-gray-600">View All Women →</a>
                        </div>
                      </div>
                    </div>
                  </li>

                  {/* Kids */}
                  <li className="relative group">
                    <span className="cursor-pointer py-5 inline-block hover:text-gray-600 transition-colors">Kids</span>
                    <div className="absolute left-0 top-full w-screen max-w-[50vw] bg-white shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                      <div className="p-8">
                        <div className="grid grid-cols-3 gap-8">
                          {kidsCategories.map((cat, idx) => (
                            <div key={idx}>
                              <h4 className="font-medium text-black text-[15px] mb-3">
                                <a href="/shop?refinementList%5Bcats%5D%5B0%5D=Kids" className="hover:text-gray-600">{cat.title}</a>
                              </h4>
                              <ul className="space-y-2">
                                {cat.items.map((item, i) => (
                                  <li key={i}><a href={item.url} className="text-[14px] text-gray-600 hover:text-black transition-colors">{item.name}</a></li>
                                ))}
                              </ul>
                            </div>
                          ))}
                        </div>
                        <div className="mt-6 text-right">
                          <a href="/shop?refinementList%5Bcats%5D%5B0%5D=Kids" className="text-sm font-medium hover:text-gray-600">View All Kids →</a>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li><a href="/campaign" className="hover:text-gray-600 transition-colors">Campaign</a></li>
                  <li><a href="/shop" className="hover:text-gray-600 transition-colors">Shop</a></li>
                  <li><a href="/corporate" className="hover:text-gray-600 transition-colors">Corporate Order</a></li>
                </ul>
              </nav>

              {/* Center Search Bar */}
              <div className="flex-1 max-w-md">
                <form action="/shop" className="relative">
                  <input
                    type="text"
                    name="query"
                    placeholder="Search Products by Titles or Tags"
                    className="w-full px-4 py-2 rounded-md text-black text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                  />
                  <button type="submit" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </button>
                </form>
              </div>

              {/* Right Icons */}
              <div className="flex items-center space-x-5 text-xl flex-shrink-0">

                {/* Profile Icon with Hover Dropdown */}
                <div className="relative group">
                  <button className="hover:text-gray-600 transition-colors flex items-center">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </button>
                  {/* Dropdown */}
                  <div className="absolute right-0 top-full mt-2 w-44 bg-white rounded-lg shadow-lg border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                    <div className="py-1">
                      <a href="/track-parcel/" className="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors">
                        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                        </svg>
                        Track Parcel
                      </a>
                      <a href="/profile" className="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors">
                        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        Profile
                      </a>
                      <div className="border-t border-gray-100 my-1" />
                      <a href="/login" className="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors">
                        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                        </svg>
                        Login
                      </a>
                    </div>
                  </div>
                </div>

                <a href="/favorites" className="hover:text-gray-600 transition-colors">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                </a>
                <a href="/cart" className="relative hover:text-gray-600 transition-colors">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">{cartCount}</span>
                </a>
              </div>

            </div>
          </div>
        </div>
      </header>

      {/* ── Mobile Header ── */}
      <header className="lg:hidden fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
        <div className="flex items-center justify-between px-4 h-[60px]">
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-2xl">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <a href="/">
            <img src="https://fabrilife.com/img/fabrilife.svg" alt="Fabrilife" className="h-7" />
          </a>
          <a href="/cart" className="relative">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center font-bold">{cartCount}</span>
          </a>
        </div>
      </header>

      {/* ── Mobile Sidebar Menu ── */}
      {mobileMenuOpen && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setMobileMenuOpen(false)} />
          <div className="fixed top-0 left-0 bottom-0 w-80 bg-white z-50 overflow-y-auto">
            <div className="p-4">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-bold">Menu</h2>
                <button onClick={() => setMobileMenuOpen(false)} className="text-2xl">&times;</button>
              </div>
              <div className="space-y-2">
                <a href="/login" className="block py-3 px-4 bg-gray-100 rounded-lg text-sm font-medium">Login/Register</a>
                <a href="/shop" className="block py-3 px-4 hover:bg-gray-50 rounded-lg">Shop</a>
                <a href="/campaign" className="block py-3 px-4 hover:bg-gray-50 rounded-lg">Campaign</a>
                <a href="/corporate" className="block py-3 px-4 hover:bg-gray-50 rounded-lg">Corporate Order</a>

                {/* Men */}
                <div className="border-t border-gray-200 pt-2 mt-2">
                  <button onClick={() => toggleCategory('men')} className="w-full flex items-center justify-between py-3 px-4 hover:bg-gray-50 rounded-lg">
                    <span className="font-medium">Men</span>
                    <svg className={`w-5 h-5 transition-transform ${expandedCategories.men ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {expandedCategories.men && (
                    <div className="pl-4 space-y-1">
                      {menCategories.map((cat, idx) => (
                        <div key={idx} className="mb-3">
                          <div className="font-medium text-sm text-gray-700 mb-1">{cat.title}</div>
                          {cat.items.map((item, i) => (
                            <a key={i} href={item.url} className="block py-2 px-3 text-sm text-gray-600 hover:bg-gray-50 rounded">{item.name}</a>
                          ))}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Women */}
                <div>
                  <button onClick={() => toggleCategory('women')} className="w-full flex items-center justify-between py-3 px-4 hover:bg-gray-50 rounded-lg">
                    <span className="font-medium">Women</span>
                    <svg className={`w-5 h-5 transition-transform ${expandedCategories.women ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {expandedCategories.women && (
                    <div className="pl-4 space-y-1">
                      {womenCategories.map((cat, idx) => (
                        <div key={idx} className="mb-3">
                          <div className="font-medium text-sm text-gray-700 mb-1">{cat.title}</div>
                          {cat.items.map((item, i) => (
                            <a key={i} href={item.url} className="block py-2 px-3 text-sm text-gray-600 hover:bg-gray-50 rounded">{item.name}</a>
                          ))}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Kids */}
                <div>
                  <button onClick={() => toggleCategory('kids')} className="w-full flex items-center justify-between py-3 px-4 hover:bg-gray-50 rounded-lg">
                    <span className="font-medium">Kids</span>
                    <svg className={`w-5 h-5 transition-transform ${expandedCategories.kids ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {expandedCategories.kids && (
                    <div className="pl-4 space-y-1">
                      {kidsCategories.map((cat, idx) => (
                        <div key={idx} className="mb-3">
                          <div className="font-medium text-sm text-gray-700 mb-1">{cat.title}</div>
                          {cat.items.map((item, i) => (
                            <a key={i} href={item.url} className="block py-2 px-3 text-sm text-gray-600 hover:bg-gray-50 rounded">{item.name}</a>
                          ))}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}